import { EnvironmentProviders, importProvidersFrom, makeEnvironmentProviders } from '@angular/core';
import { DfAccountModule } from '@df/account/df-account.module';
export function provideAccount(): EnvironmentProviders {
    return makeEnvironmentProviders([
        importProvidersFrom(
            DfAccountModule.forRoot({
                navigation: [
                    { icon: 'box', label: 'Order History', link: '/account/my-orders' },
                    { icon: 'account', label: 'Account Details', link: '/account/edit' },
                    { icon: 'home', label: 'Address Book', link: '/account/address-book' },
                    { icon: 'account', label: 'Sales Contact', link: '/account/sales-contact', trade: true },
                    { icon: 'card', label: 'Payment Methods', link: '/account/payment-methods' },
                    { icon: 'wishlist', label: 'Your Wishlist', link: '/account/wishlist', trade: false },
                    { icon: 'contact', label: 'Information Centre', link: '/account/information-centre', trade: true },
                    {
                        icon: 'download',
                        label: 'Trade Quick Buy',
                        link: '/account/quick-buy',
                        trade: true,
                        isHidden: true
                    },
                    // { icon: 'symbol-list', label: 'Allowed Categories', link: '/account/allowed-categories', trade: true },
                    { icon: 'download', label: 'Stock Level Report', link: '/account/stock-level-report', trade: true },
                    // { icon: 'contact', label: 'Refer a Friend', link: '/account/refer-a-friend', stores: ['uk'] },

                    // Standalone
                    { icon: 'reward', label: 'My Rewards', link: '/account/my-rewards', standaloneOnly: true, twoColumns: true },
                    { icon: 'box', label: 'Order History', link: '/account/my-orders', standaloneOnly: true },
                    { icon: 'account', label: 'My Profile', link: '/account/edit', standaloneOnly: true },
                    { icon: 'horse', label: 'My Outfits', link: '/account/my-outfits', standaloneOnly: true },
                    { icon: 'wishlist', label: 'Wishlist', link: '/account/wishlist', standaloneOnly: true, trade: false },
                    // { icon: 'rewards', label: 'Refer a Friend', link: '/account/refer-a-friend', stores: ['uk'], standaloneOnly: true },
                    { icon: 'home', label: 'Address Book', link: '/account/address-book', standaloneOnly: true },
                    { icon: 'card', label: 'Payment Methods', link: '/account/payment-methods', standaloneOnly: true },
                    { icon: 'settings', label: 'Settings', link: '/account/settings', standaloneOnly: true, twoColumns: true }
                ]
            })
        )
    ]);
}
